import BorrowerDashboard from './borrower-dashboard';

export default BorrowerDashboard;
